import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { RootState } from '../../store';
import { cookieShareDomain } from '../../services/singnin.service';
import { resetUserSession } from '../session/resetUserSession';

export function useIsLoggedIn() {
  const {
    singIn: {
      auth: { oya_oyana_access_token, expiredToken }
    }
  } = useSelector((state: RootState) => state);
  const [logged, setLogged] = useState(false);

  useEffect(() => {
    if (oya_oyana_access_token.length > 0 && expiredToken === false) {
      setLogged(true);
    } else setLogged(false);
  }, [oya_oyana_access_token, expiredToken]);

  return logged;
}

export function useLogout() {
  const [, , removeCookie] = useCookies(['oya_oyana_access_token']);
  const dispatch = useDispatch();
  const logOut = () => {
    removeCookie('oya_oyana_access_token', { domain: cookieShareDomain });
    resetUserSession(dispatch);
  };
  return [logOut];
}
